import { css } from "@emotion/react";
import fontSize from "assets/css/fontSize";

export default css`
  text-overflow: ellipsis;
  width: calc(100% - 20px);
  overflow: hidden;
  white-space: nowrap;
  font-size: ${fontSize.sm};
`;
